import { factory } from '../../../../utils/apiThunkFactory';

export const getAgent = factory.get('avatar/getAgent', '/api/agent/get');
export const toggleAgentStatus = factory.post('avatar/updateagentstatus', '/api/agent/updateagentstatus/:name');